var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-safe-space"},[_c('div',{staticClass:"width-limited"},[(!_vm.form.isReady())?_c('loader'):_c(_vm.component,{ref:"form",tag:"component",attrs:{"form":_vm.form,"processing":_vm.form.processing},on:{"submit":_vm.submit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }